// ── BURGER / DRAWER ────────────────────────────────────────
(function () {
  var burger = document.getElementById('nav-burger');
  var drawer = document.getElementById('nav-drawer');
  if (!burger || !drawer) return;

  function setOpen(open) {
    burger.classList.toggle('is-open', open);
    drawer.classList.toggle('is-open', open);
    document.body.classList.toggle('drawer-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  burger.addEventListener('click', function () { setOpen(!drawer.classList.contains('is-open')); });

  var closeBtn = document.getElementById('drawer-close');
  if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); });

  drawer.querySelectorAll('[data-drawer-link]').forEach(function (a) {
    a.addEventListener('click', function () { setOpen(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
  });
})();

// ── MEGA MENU ───────────────────────────────────────────────
(function () {
  var trigger = document.getElementById('collections-trigger');
  var menu = document.getElementById('mega-menu');
  if (!trigger || !menu) return;

  var timer;
  function open() { clearTimeout(timer); menu.classList.add('open'); }
  function close() { timer = setTimeout(function () { menu.classList.remove('open'); }, 120); }

  trigger.addEventListener('mouseenter', open);
  trigger.addEventListener('mouseleave', close);
  menu.addEventListener('mouseenter', open);
  menu.addEventListener('mouseleave', close);
})();

// ── COLLECTIONS RAIL DRAG ──────────────────────────────────
(function () {
  var rail = document.querySelector('.collections-rail');
  if (!rail) return;
  var isDown = false, startX, scrollLeft;
  rail.addEventListener('mousedown', function (e) { isDown = true; startX = e.pageX - rail.offsetLeft; scrollLeft = rail.scrollLeft; rail.classList.add('dragging'); });
  document.addEventListener('mouseup', function () { isDown = false; rail.classList.remove('dragging'); });
  rail.addEventListener('mousemove', function (e) { if (!isDown) return; e.preventDefault(); var x = e.pageX - rail.offsetLeft; rail.scrollLeft = scrollLeft - (x - startX) * 1.5; });

  var prev = document.getElementById('coll-prev');
  var next = document.getElementById('coll-next');
  if (prev && next) {
    prev.addEventListener('click', function () { rail.scrollBy({ left: -400, behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: 400, behavior: 'smooth' }); });
  }
})();

// ── HOW IT WORKS — SCROLL-DRIVEN STEPS ─────────────────────
(function () {
  var section = document.querySelector('.how-section');
  if (!section) return;
  var steps = section.querySelectorAll('.how-step');
  var images = section.querySelectorAll('.how-image');
  var dots = section.querySelectorAll('.how-dots li');
  var bar = section.querySelector('.how-progress-bar');
  var totalSteps = steps.length;

  function activate(idx) {
    steps.forEach(function (s, i) {
      var show = i === idx;
      s.classList.toggle('is-active', show);
      s.style.opacity = show ? '1' : '0';
      s.style.transform = show ? 'translateY(0)' : (i < idx ? 'translateY(-20px)' : 'translateY(20px)');
    });
    images.forEach(function (img, i) { img.classList.toggle('is-active', i === idx); });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    if (bar) bar.style.transform = 'scaleX(' + ((idx + 1) / totalSteps) + ')';
  }

  activate(0);

  window.addEventListener('scroll', function () {
    var rect = section.getBoundingClientRect();
    var progress = -rect.top / (rect.height - window.innerHeight);
    var idx = Math.min(totalSteps - 1, Math.max(0, Math.floor(progress * totalSteps)));
    activate(idx);
  }, { passive: true });
})();

// ── STATIONERY "OTHER" TOGGLE ──────────────────────────────
(function () {
  var otherCb = document.querySelector('input[value="Other"]');
  var otherText = document.querySelector('.other-text');
  if (!otherCb || !otherText) return;
  otherText.style.display = 'none';
  otherCb.addEventListener('change', function () {
    otherText.style.display = this.checked ? 'block' : 'none';
  });
})();
